import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './api';
import { Meeting } from '@clareefai/types';

export const meetingApi = createApi({
  reducerPath: 'meetingApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Meeting'],
  endpoints: (builder) => ({
    getVendorMeetings: builder.query<Meeting[], void>({
      query: () => '/vendors/me/meetings',
      providesTags: ['Meeting'],
    }),
    updateMeetingStatus: builder.mutation<Meeting, { id: string; status: Meeting['status'] }>({
      query: ({ id, status }) => ({
        url: `/vendors/me/meetings/${id}/status`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: ['Meeting'],
    }),
  }),
});

export const {
  useGetVendorMeetingsQuery,
  useUpdateMeetingStatusMutation,
} = meetingApi;

